import React from "react";
import Lottie from "react-lottie";
import loadingAnimation from "./loading.json";

const FullScreenLoader = ({ loading = false }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  if (!loading) return null;
  return (
    <div className="fullscreenloader">
      <Lottie options={defaultOptions} height={300} width={300} />
    </div>
  );
};

export default FullScreenLoader;
